
import Vue from "vue";
import { Component } from "vue-property-decorator";
import IconButton from "@/components/UI/IconButton.vue";
import { uiStore, singularityStore } from "@/store/store";

export const PHONE_PORTRAIT_BREAKPOINT_ID = "breakpoint_phone_portrait";

@Component({
  components: {
    IconButton
  }
})
export default class TopNavToggleMobile extends Vue {
  get currentBreakpoint() {
    return uiStore.currentBreakpoint.id;
  }

  get isPreviewMode() {
    return singularityStore.previewMode;
  }

  togglePreviewMode() {
    singularityStore.togglePreviewMode();
  }
}
